import { FC, useState } from "react";
import GText from "./GText";
import { css } from "@emotion/react";
import { BaseProps } from "./text";

interface Prop {
  text?: string;
  duration?: number;
}

const GTextBlur: FC<Prop & BaseProps> = (props) => {
  const [hoveredIndex, setHoveredIndex] = useState(-1);

  const styles = css`
    text-align: center;

    & span {
      display: inline-block;
      position: relative;
      transition: filter 0.3s ease;

      &.hovered {
        filter: blur(0px);
      }
    }
  `;

  const handleCharHover = (index: number) => {
    setHoveredIndex(index);
  };

  const calculateBlurAmount = (charIndex: number, hoveredIndex: number) => {
    if (hoveredIndex === -1) {
      return 8; // Default blur amount
    }

    const distance = Math.abs(charIndex - hoveredIndex);
    return distance * 2; // Adjust the factor as needed ( more value will make closer element affected only)
  };

  const splitTextIntoSpan = () => {
    return props.text?.split("").map((l, index) => (
      <span
        key={index}
        className={`${hoveredIndex === index ? "hovered" : ""}`}
        style={{
          filter: `blur(${calculateBlurAmount(index, hoveredIndex)}px)`,
        }}
        onMouseEnter={() => handleCharHover(index)}
        onMouseLeave={() => handleCharHover(-1)}
      >
        {l}
      </span>
    ));
  };

  return (
    <GText {...props}>
      <div css={styles}>{splitTextIntoSpan()}</div>
    </GText>
  );
};

GTextBlur.defaultProps = {
  text: "Grooody",
  fontSize: 50,
  color: "#000",
};
export default GTextBlur;

/*
addPropertyControls(TextGlitch, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
})
*/
